export default {

  title: '极昼(香港)内购系统',

  // siteLogo: require('../assets/xcxd-logo.jpg'),
  siteTitle: 'PERPETUALDAY (HK) ',
  loginBackground: require('../assets/login/xcxd-background.jpg'),
  qrcodes: [],
  copyright: 'PERPETUALDAY(HK)LIMITED',
  icp: '',
  customerService: {
    tel: '400-016-9197',
    time: '(周一至周日 9:00-21:00)'
  },

  api: {
    baseURL: 'https://api.jizhouhk.cn/web'
  },

  client: {
    web: {
      baseUrl: 'https://jizhouhk.cn',
    },
    admin: {
      baseUrl: 'http://dashboard.jizhouhk.cn',
    },
  },

  payMethod: {
    aliPay: false,
    wxPay: false,
    aliPayGlobal: false,
    antom: true,
  }
}
